import { post } from '@/api/request'
import { BResponse } from '@/api/base'

// upload
export interface UploadRequest {
  file: File
  collection: string
  filename: string
}

// 品牌产品
export interface UploadResponse {
  fileCode: string
  fileName: string
  fileSize: number
  screenshot: string
  url: string
}

/**
 * upload public file
 */
export const uploadFileByPublic = (params: FormData) => {
  return post<BResponse<UploadResponse>>(' /authenti-guard/v1/file/public', params)
}
